import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAccessLogsAction,
  deleteAccessLogAction,
} from "../Actions/AdminAccessLogsAction";

const initialState = {
  accessLogs: {},
  deleteAccessLog: {},
};

export const adminAccessLogsSlice = createSlice({
  name: "adminAccessLogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccessLogsAction.fulfilled, (state, action) => {
        state.accessLogs = action.payload;
      })
      .addCase(deleteAccessLogAction.fulfilled, (state, action) => {
        state.deleteAccessLog = action.payload;
      });
  },
});

export default adminAccessLogsSlice.reducer;